import { createApp } from 'vue'
import FeatureMaskComponent from '@/plugins/ar-feature-mask/FeatureMask.vue'

// Function to create a new FeatureMaskComponent instance
const createFeatureMaskInstance = (values: any) => {
  const container = document.createElement('div') // Create a container for the component
  container.style.position = 'absolute' // Ensure it overlays correctly
  container.style.top = '0'
  container.style.left = '0'
  container.style.width = '100%'
  container.style.height = '100%'
  container.style.display = values.show ? 'flex' : 'none'

  // Create the app instance
  const app = createApp(FeatureMaskComponent, values)

  // Mount the app instance directly into the container
  const vm = app.mount(container)

  return { app, container, vm }
}

// Function to update the FeatureMaskComponent props
const updateFeatureMaskInstance = (instance: any, values: any) => {
  if (instance.vm) {
    // In Vue 3, we need to recreate the component with new props instead of direct mutation
    const container = instance.container
    if (container) {
      // Update container display based on visibility
      container.style.display = values.show ? 'flex' : 'none'

      // Unmount the previous app
      instance.app.unmount()

      // Create a new app with updated props
      const app = createApp(FeatureMaskComponent, values)
      instance.app = app

      // Mount the new app to the same container
      instance.vm = app.mount(container)
    }
  }
}

// Function to destroy the FeatureMaskComponent instance
const destroyFeatureMaskInstance = (instance: any) => {
  if (instance.app) {
    instance.app.unmount() // Unmount the app
    if (instance.container && instance.container.parentNode) {
      instance.container.parentNode.removeChild(instance.container) // Remove the container from DOM
    }
  }
}

// Directive definition
const ARFeatureLocker = {
  install(app: any) {
    app.directive('ar-feature-mask', {
      mounted(el, binding) {
        if (!el.style.position) {
          el.style.position = 'relative'
        }

        // Create a new instance of the FeatureMaskComponent
        const instance = createFeatureMaskInstance(binding.value)
        el.featureLockerInstance = instance // Attach the instance to the element
        el.appendChild(instance.container) // Append the container to the DOM
      },
      updated(el, binding) {
        if (el.featureLockerInstance) {
          updateFeatureMaskInstance(el.featureLockerInstance, binding.value)
        }
      },
      unmounted(el) {
        if (el.featureLockerInstance) {
          destroyFeatureMaskInstance(el.featureLockerInstance)
          delete el.featureLockerInstance // Cleanup the instance
        }
      },
    })
  },
}

export default ARFeatureLocker
